// 💾 routes/AdminProtectedRoute.tsx
import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useAuthProfileGuard } from "../hooks/useAuthProfileGuard"

const AdminProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  const { user, role, authLoading, profileLoading } = useAuthProfileGuard()

  if (authLoading || profileLoading) return <div>Loading...</div>

  // Not logged in → redirect to admin login
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />
  }

  // Normalize role before checking
  const normalizedRole = role?.toLowerCase()

  if (normalizedRole !== "admin") {
    console.log("❌ ROLE mismatch:", { role, requiredRole: "admin" })
    return <Navigate to="/admin/login" replace />
  }

  return <>{children}</>
}

export default AdminProtectedRoute
